import { ENTORNO } from "../utils/constantes";
import { getIdioma, getToken } from "../utils/variablesLocales";

export class apiTexto {
  baseApi = ENTORNO.BASE_API;

  async obtener(Tipo) {
    try {
      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Texto_Obtener
      }?Idioma=${getIdioma()}&Tipo=${Tipo}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async obtenerTodos() {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Texto_Obtener}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async actualizar(Id, Tipo, Idioma, Texto, Activo) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Texto_Actualizar}/${Id}`;

      const parametros = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          Tipo: Tipo,
          Idioma: Idioma,
          Texto: Texto,
          Activo: Activo,
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async borrar(Id) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Texto_Borrar}/${Id}`;

      const parametros = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }
}
